import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import Button from '../../../components/button/Button';

import './referSection.scss';

export default function ReferSection() {
  return (
    <section id="refer" className="refer">
      <StaticImage className="illustration" src="../../../images/index/refer.png" alt="" />
      <div className="content">
        <h2>
          <span className="salmon">Refer</span>
          &nbsp;a patient
        </h2>
        <h6>
          Do you have a patient struggling with their sleep or at risk of developing a
          sleep condition? We’re here to help.
        </h6>
        <Button
          text="Refer patient"
          displayArrow
          dataAttr="CTA_clicked_refer"
          className="blue"
          link="/Dreem Health Sleep Clinic Fax Form.pdf"
          target="_blank"
        />
      </div>
    </section>
  );
}
